import config from 'config';
const IS_SNAP = /ReactSnap/.test(navigator.userAgent);
// The runtime prerender service (prerender-service/, UA "Profitroll-Prerender")
// is NOT react-snap — IS_SNAP is false during it, so IS_SNAP guards never fired
// for crawler renders. Use this for anything that should be skipped when the
// snapshot is being taken.
const IS_PRERENDER = /Profitroll-Prerender/i.test(navigator.userAgent);
const SNAP_LOCALIZED = process.env.REACT_APP_SNAP_LOCALIZED === '1';
// Wired from GitHub Variables (GOOGLE_ADSENSE_ACTIVE) at build time. When
// not "true", no AdSense script, <ins> tag, or surrounding placement markup
// is emitted — call sites must gate on this, not just the AdSense component.
const ADSENSE_ACTIVE = process.env.REACT_APP_GOOGLE_ADSENSE_ACTIVE === 'true';

// Detect search engine bots to avoid geo-redirecting them
// This prevents Google Search Console from reporting redirect errors
const IS_BOT = typeof navigator !== 'undefined' && /googlebot|bingbot|yandexbot|duckduckbot|slurp|baiduspider|facebot|facebookexternalhit|twitterbot|rogerbot|linkedinbot|embedly|quora link preview|showyoubot|outbrain|pinterest|applebot|semrushbot|ahrefsbot|mj12bot|petalbot/i.test(navigator.userAgent);
const SNAP_SHOT_LIMIT = 100;
const PER_PAGE_MAX_LIMIT = 100;
const WORDS_PER_MINUTE = 200;
const CHECK_PAYMENT_INTERVAl = 10000;
const COLUMNS_LIMIT_DEFAULT = 6;
const COLUMNS_LIMIT = 3;
const MAX_MESSAGE_LIMIT = 5000;
const BREADCRUMBS_LENGTH = 70;

const STATUSES = (theme) => ({
  created: theme.palette.textPrimary.main,
  processing: theme.palette.textPrimary.main,
  hold: theme.palette.textPrimary.main,
  success: theme.palette.primary.main,
  failure: theme.palette.error.main,
  reversed: theme.palette.error.main,
  expired: theme.palette.error.main
});

const DAILY = {
  init: 'init',
  login: 'login',
  readArticle: 'readArticle',
  readProfession: 'readProfession',
  goToJobVacancy: 'goToJobVacancy',
  readEducationalProgram: 'readEducationalProgram',
  leaveReview: 'addQuestionOrReview',
  answerQuestion: 'answerQuestion'
};

const POLICY_LINKS = {
  '66ab5444d55c54bab7eb4550': '/policy/refund',
  '66ab534302fd2ab0db759ee2': '/policy/privacy',
  '66b331f95ade56d05987955c': '/policy/cookie',
  '66b333a85ade56d059879597': '/policy'
};

const PROFITROLL_URL = config.rootUrl || 'https://profitroll.com.ua/';
const JOBALTO_URL = 'jobalto.com';

const PROFITROLL_URL_LANGUAGES = ['ua'];

const SUPPORTED_LOCALES = [
  'ua',
  'ru',
  'bg',
  'ca',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'et',
  'fi',
  'fr',
  'hr',
  'hu',
  'hy',
  'is',
  'it',
  'ka',
  'lt',
  'lv',
  'mk',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'sk',
  'sl',
  'sq',
  'sr',
  'sv',
  'tr'
];
const MAX_SIZE = 10 * 1024 * 1024;

export {
  IS_SNAP,
  IS_PRERENDER,
  IS_BOT,
  SNAP_LOCALIZED,
  ADSENSE_ACTIVE,
  SNAP_SHOT_LIMIT,
  PER_PAGE_MAX_LIMIT,
  WORDS_PER_MINUTE,
  CHECK_PAYMENT_INTERVAl,
  COLUMNS_LIMIT,
  COLUMNS_LIMIT_DEFAULT,
  STATUSES,
  MAX_MESSAGE_LIMIT,
  DAILY,
  BREADCRUMBS_LENGTH,
  POLICY_LINKS,
  JOBALTO_URL,
  SUPPORTED_LOCALES,
  PROFITROLL_URL_LANGUAGES,
  PROFITROLL_URL,
  MAX_SIZE
};
